export const getIdModel = () => {
  let idModel = 0;
  if (cube.$('.model-selection.slick-current'))
    idModel = cube.$('.model-selection.slick-current').dataset.modelId;
  else idModel = cube.$('.js-default-model').dataset.modelId;

  return idModel;
};

export const getIdSku = () => {
  let idSku = 0;
  if (cube.$('#conversion-zone .sizes__size--selected'))
    idSku = cube.$('#conversion-zone .sizes__size--selected').dataset.id;

  return idSku;
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/pdp-utils.js